import React from 'react';

// Social login icons
const GoogleIcon = () => (
  <svg className="social-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const MicrosoftIcon = () => (
  <svg className="social-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="8.5" height="8.5" fill="#F25022"/>
    <rect x="12.5" y="3" width="8.5" height="8.5" fill="#7FBA00"/>
    <rect x="3" y="12.5" width="8.5" height="8.5" fill="#00A4EF"/>
    <rect x="12.5" y="12.5" width="8.5" height="8.5" fill="#FFB900"/>
  </svg>
);

const FacebookIcon = () => (
  <svg className="social-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.47H7.078V12h3.047V9.356c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z" fill="#1877F2"/>
  </svg>
);

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

function SignupStep1({ onEmailSignup }) {
  return (
    <div className="signup-card">
      <div className="signup-buttons">
        {/* Primary Email Button */}
        <button className="btn-primary" onClick={onEmailSignup}>
          <span>Sign up with Email</span>
          <ArrowIcon />
        </button>

        {/* Divider */}
        <div className="divider">
          <span className="divider-line"></span>
          <span className="divider-text">or continue with</span>
          <span className="divider-line"></span>
        </div>

        {/* Social Login Buttons */}
        <div className="social-buttons">
          <button className="btn-social">
            <span className="btn-social-icon"><GoogleIcon /></span>
            <span className="btn-social-text">Sign up with Google</span>
          </button>

          <button className="btn-social">
            <span className="btn-social-icon"><MicrosoftIcon /></span>
            <span className="btn-social-text">Sign up with Microsoft</span>
          </button>

          <button className="btn-social">
            <span className="btn-social-icon"><FacebookIcon /></span>
            <span className="btn-social-text">Sign up with Facebook</span>
          </button>
        </div>

        {/* Login Link */}
        <p className="login-text">
          Already have an account? <a href="/login" className="login-link">Log in</a>
        </p>
      </div>
    </div>
  );
}

export default SignupStep1;

